import Loadable from 'react-loadable';

const FeedbackDialogLazy = Loadable({
	loader: () => import(/* webpackChunkName: "async-ptc_feedback-dialog" */ './FeedbackCollector'),
	loading: () => null,
});
FeedbackDialogLazy.displayName = 'lazy(FeedbackDialog)';

export default FeedbackDialogLazy;
